<template>
    <div class="index">
        <div style="margin-bottom: 10px">
            <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>账户添加</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card>
            <el-form ref="ruleForm" :rules="rules" :model="form" style="margin-top: 10px">
                <el-row :gutter="10">

                    <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                        <el-form-item label="账号名称:" prop="username" label-width="90px">
                            {{member.username}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">

                    <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                        <el-form-item label="密码修改:" prop="username" label-width="90px">
                            <el-switch
                                    v-model="is_password"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10" v-if="is_password">

                    <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" >

                        <el-form-item label="旧密码:" prop="password" label-width="90px">
                            <el-input type="password"  v-model="form.password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10" v-if="is_password">

                    <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                        <el-form-item label="新密码:" prop="confirm_password" label-width="90px">
                            <el-input type="password"  v-model="form.confirm_password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">

                    <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                        <el-form-item label="用户昵称:" label-width="90px">
                            <el-input type="text"  v-model="form.nick_name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">

                    <el-col el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                        <el-form-item label="用户角色" prop="roles_id" label-width="90px">
                            <el-select v-model="form.roles_id" placeholder="请选择" prop="roles_id"  >
                                <el-option
                                        v-for="item in options"
                                        :key="item.en_name"
                                        :label="item.cn_name"
                                        :value="item.id" >
                                </el-option>

                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">

                    <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" style="padding-left: 100px">
                        <el-form-item >
                            <el-button type="primary" @click="submitForm('ruleForm')">编辑账户</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </el-card>
    </div>
</template>

<script>
    import { mapActions, mapState } from "vuex";

    export default {

        data() {

            let reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,12}$/
            var validateNewPwd = (rule, value, callback) => {
                if (!reg.test(value)) {

                    callback(new Error('密码应是6-12位数字、字母或字符组合'))
                } else {
                    callback()
                }
            }
            var validateComfirmPwd = (rule, value, callback) => {
                if (!reg.test(value)) {
                    callback(new Error('密码应是6-12位数字、字母或字符组合'))

                } else {
                    callback()
                }
            }
            return {
                options:[],
                member:{},
                is_password:false,
                form: {
                    password: "",
                    roles_id:"",
                    confirm_password:"",

                    nick_name:""
                },

                rules: {

                    password: [
                        {
                            required: true,
                            message: "请旧输入密码",
                            trigger: "blur",
                        },

                        { validator: validateNewPwd, trigger: 'blur' }
                    ],
                    confirm_password: [
                        {
                            required: true,
                            message: "请输入新密码",
                            trigger: "blur",
                        },
                        { validator: validateComfirmPwd, trigger: 'blur' }
                    ],
                    roles_id: [
                        {
                            required: true,
                            message: "请选择角色",
                            trigger: "blur",
                        },

                    ],
                },

            };
        },
        methods: {
            ...mapActions({
                addMemberAction: "addMemberAction",
                editMemberAction: "editMemberAction",
            }),

            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.editMemberAction({
                            password:this.form.password,
                            new_password:this.form.confirm_password,
                            roles_id:this.form.roles_id,
                            nick_name:this.form.nick_name,
                            type:1,
                            is_password:this.is_password?1:0,
                            id:this.id
                        });
                    } else {

                        console.log("error submit!!");
                        return false;
                    }
                });
            },
        },

        mounted() {
            this.id=this.$route.params.id
            this.addMemberAction({type:0})
            this.editMemberAction({type:0,id:this.id})
        },
        computed: {
            //   ...mapState({dataIndex:"index.dataIndex"}),
            ...mapState({
                result: (state) => state.member.result,
            }),
        },
        watch: {
            result(val) {
                if(val.code==200){

                    this.options=val.data
                }
                if(val.code==201){

                    this.member=val.data
                    this.form.roles_id=val.data.roles_id
                    this.form.nick_name=val.data.nickname

                }

                if (val.code == 303) {
                    this.$message({
                        message: "账户编辑成功",
                        type: "success",
                    });
                }

                if (val.code == 401) {
                    this.$message("请输入正确旧密码",);
                }
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>



</style>
